import { killshotApi } from '../api';

const V0 = 'v0';
const V1 = 'v1';
const V2 = 'v2';

export const setEventLinks = async (baseURL, eventURL) => {
  return killshotApi.post(baseURL, { url: eventURL });
};

export const auditTrail = async (objectId = 0, event = 'open', objectType) => {
  return killshotApi.post('/v1/event/audit_trail', {
    object_type: objectType,
    object_id: objectId,
    event,
    diff: null,
  });
};

export const fetchGroups = async eventId => {
  const response = await killshotApi.get(`${V1}/groups/?event_id=${eventId}`);
  return response;
};

export const fetchGroupsBasicInfo = async eventId => {
  const response = await killshotApi.get(`${V2}/groups/?event_id=${eventId}`);
  return response;
};

export const fetchGroupsRanksComps = async (eventId, groupsIds) => {
  const response = await killshotApi.get(`${V2}/groups/ranks_comps/?event_id=${eventId}&groups_ids=${groupsIds}`);
  return response;
};

export const fetchSettings = async () => {
  const response = await killshotApi.get(`${V1}/admin/config`);
  return response;
};

export const updateSettings = async (listPrice = 0, attr) => {
  const payload = {};
  payload[attr] = listPrice;

  killshotApi.put(`${V1}/admin/config`, payload);
};

export const fetchTags = async () => {
  const response = await killshotApi.get(`${V1}/pricing_strategies`);
  return response;
};

export const fetchInventory = async (eventId, isGrouped) => {
  const response = await killshotApi.get(`${V1}/inventory/?event_id=${eventId}&grouped=${isGrouped}`);
  return response;
};

export const fetchInteractiveGraphs = async id => {
  try {
    let response = await killshotApi.get(`${V1}/graphs/${id}/held_over_time_by_cost_interactive`);

    if (typeof response === 'string') {
      const validJsonText = response.replace(/\bNaN\b/g, 'null');
      response = JSON.parse(validJsonText);
    }

    if (response?.status !== 'success' || response?.response?.status !== 'ok') {
      return { status: 'error', message: 'Failed to fetch graph data from API' };
    }

    const { data, name, display_name: displayName } = response.response;

    return {
      status: 'success',
      data: {
        name,
        displayName,
        graphData: data,
      },
    };
  } catch (error) {
    return { status: 'error', message: error.message || 'Failed to fetch interactive graphs' };
  }
};

export const fetchEventMeta = async eventId => {
  const response = await killshotApi.get(`${V1}/event_meta?event_id=${eventId}`);
  return response;
};

export const fetchGlobalSettings = async () => {
  const response = await killshotApi.get(`${V1}/event_meta/config`);
  return response;
};

export const fetchEventStats = async eventId => {
  const response = await killshotApi.get(`${V1}/event_stats?event_id=${eventId}`);
  return response;
};

export const forceRefresh = async (eventId, marketplace) => {
  const response = await killshotApi.post(`${V1}/event/${eventId}/force_refresh?marketplace=${marketplace}`);
  return response;
};

export const fetchSBEventMeta = async id => {
  const response = await killshotApi.get(`${V1}/event/${id}`);
  return response;
};

export const fetchListings = async eventId => {
  const response = await killshotApi.get(`${V0}/stubhub/listings?event_id=${eventId}`);
  return response;
};

export const deletePricingGroup = async (groupId, isTransfer = null, toId = null) => {
  try {
    const url = `v1/groups/?killshot_group_id=${groupId}&is_transfer=${isTransfer}&to_id=${toId}`;
    const response = killshotApi.delete(url);
    return response;
  } catch (e) {
    throw e;
  }
};

export const fetchManagementTags = async () => {
  try {
    const response = await killshotApi.get(`${V1}/management/tags`);
    if (!response) return [];
    return response.response;
  } catch (e) {
    throw e;
  }
};

export const pushEventPrices = async skyboxId => {
  const response = await killshotApi.post(`v1/${process.env.SEARCH_API_URI}${skyboxId}/push`);
  return response;
};

export const saveEventLink = async (skyboxEventId, marketplaceURL, marketplaceName) => {
  try {
    const response = await killshotApi.post(`${V1}/event/event_link/${skyboxEventId}`, {
      marketplace: marketplaceName,
      url: marketplaceURL,
    });

    if (response) {
      return response.response;
    }

    return response;
  } catch (e) {
    throw e;
  }
};

export const createNewOrganization = async (orgName, orgTag, includePrimeBrokerage) => {
  try {
    const response = await killshotApi.post(`${V1}/admin/config/organizations`, {
      name: orgName,
      tag: orgTag,
      includePrime: includePrimeBrokerage,
    });

    return response;
  } catch (e) {
    throw e;
  }
};

export const updateOrganization = async (orgId, orgName, orgTag, includePrimeBrokerage) => {
  try {
    const response = await killshotApi.put(`${V1}/admin/config/organizations`, {
      id: orgId,
      name: orgName,
      tag: orgTag,
      includePrime: includePrimeBrokerage,
    });

    return response;
  } catch (e) {
    throw e;
  }
};

export const tmMatching = async (skyboxEventId, lobsangEventId, tmUrl) => {
  try {
    const response = await killshotApi.post(`${V1}/event/tm_matching`, {
      skybox_event_id: skyboxEventId,
      lobsang_event_id: lobsangEventId,
      tm_url: tmUrl,
    });

    return response;
  } catch (e) {
    throw e;
  }
};

export const createGroup = async (skyboxId, groupPayload) => {
  try {
    const response = await killshotApi.put(`v1/groups?event_id=${skyboxId}`, groupPayload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveGroup = async (skyboxId, groupPayload) => {
  try {
    const response = await killshotApi.post(`v2/event/${skyboxId}/save`, groupPayload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const pushGroup = async (skyboxId, groupsPayload) => {
  try {
    const response = await killshotApi.post(`v2/event/${skyboxId}/push`, groupsPayload);
    return response;
  } catch (error) {
    throw error;
  }
};
